module.exports = __webpack_public_path__ + "media/email.2fad7ff6.svg";